import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      meta: { title: 'Home' },
    },
    {
      path: '/callback',
      name: 'Callback',
      component: () => import(/* webpackChunkName: "callback" */ '@/views/Callback.vue'),
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import(/* webpackChunkName: "home" */ '@/_user/Profile.vue'),
      meta: { requiresLogin: true, title: 'My Profile' },
    },
    {
      path: '/book-search',
      name: 'BookSearchByISBN',
      component: () =>
        import(/* webpackChunkName: "book-search" */ '@/_books/BookSearchByISBN.vue'),
      meta: { requiresLogin: true, title: 'Book Search' },
    },
    {
      path: '/sellers',
      name: 'Sellers',
      component: () => import('@/_sellers/Sellers.vue'),
      meta: { requiresLogin: true, title: 'Sellers' },
    },
    {
      path: '/sellers/add',
      name: 'NewSeller',
      component: () => import('@/_sellers/SellerEdit.vue'),
      meta: { requiresLogin: true, title: 'New Seller' },
    },
    {
      path: '/sellers/edit',
      name: 'EditSeller',
      component: () => import('@/_sellers/SellerEdit.vue'),
      meta: { requiresLogin: true, title: 'Edit Seller' },
    },
    {
      path: '/offer-cart',
      name: 'OfferCart',
      component: () => import('@/_offers/OfferCart.vue'),
      props: true,
      meta: { requiresLogin: true, title: 'Offer Cart' },
    },
    {
      path: '/my-offers',
      name: 'MyOffers',
      component: () => import('@/_offers/MyOffers.vue'),
      props: true,
      meta: { requiresLogin: true, title: 'My Offers' },
    },
    {
      path: '/offer-review',
      name: 'ReviewOffer',
      component: () => import('@/_offers/ReviewOffer.vue'),
      props: true,
      meta: { title: 'Review Offer' },
    },
    {
      path: '/check-in',
      name: 'Check-In',
      component: () => import('@/_check-in/CheckIn.vue'),
      props: true,
      meta: { title: 'Check-In' },
    },
    {
      path: '/*',
      redirect: { name: 'Home' },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin) && !store.getters['auth/getLoggedIn']) {
    next('/home')
  } else {
    next()
  }
})

export default router
